import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { Database } from '../database.types';

const checkEnv = (key: string, value: string | undefined): string => {
  if (!value || !value.trim()) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value.trim();
};

export const getSupabaseUrl = () => checkEnv('NEXT_PUBLIC_SUPABASE_URL', process.env.NEXT_PUBLIC_SUPABASE_URL);
export const getSupabaseAnonKey = () => checkEnv('NEXT_PUBLIC_SUPABASE_ANON_KEY', process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY);
export const getSupabaseServiceRoleKey = () => checkEnv('SUPABASE_SERVICE_ROLE_KEY', process.env.SUPABASE_SERVICE_ROLE_KEY);

let serviceClient: SupabaseClient<Database> | null = null;

/**
 * Returns a singleton service-role client. Use only in trusted server contexts.
 */
export const getServiceClient = (): SupabaseClient<Database> => {
  if (serviceClient) return serviceClient;
  serviceClient = createClient<Database>(getSupabaseUrl(), getSupabaseServiceRoleKey());
  return serviceClient;
};

// Test-only helper to clear cached client between test runs.
export const __resetServiceClientForTests = () => {
  serviceClient = null;
};

